// extracted by mini-css-extract-plugin
export default {"container":"G0-z"};